import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@spz/ui/components/accordion";
import Markdown from "marked-react";
import { type FC, useRef, useState } from "react";
import type { ControlDescriptionParserOutput } from "../utils/control-description-parser";

interface ControlDescriptionProps {
  sections: ControlDescriptionParserOutput["sections"];
}

const ControlDescription: FC<ControlDescriptionProps> = ({ sections }) => {
  const [openItems, setOpenItems] = useState<string[]>(
    sections.slice(0, 1).map((section) => section.id),
  );

  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="bg-white p-4 rounded relative transition-all duration-300 ease-in-out">
      <div ref={contentRef} className="pb-4">
        <Accordion
          type="multiple"
          value={openItems}
          onValueChange={setOpenItems}
        >
          {sections.map((section) => (
            <AccordionItem
              key={section.id}
              value={section.id}
              className="border-b border-gray-200"
            >
              <AccordionTrigger className="flex items-center justify-between">
                {section.title}
              </AccordionTrigger>
              <AccordionContent className="pt-2 [&>ol]:mb-2 [&>ol]:list-decimal [&>ol]:list-inside [&>ul]:list-disc [&>ul]:list-inside">
                <Markdown>{section.content}</Markdown>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default ControlDescription;
